module.exports = __webpack_public_path__ + "img/As.87124116.png";